import { render, staticRenderFns } from "./AdminResetSharedAccountPasswordPopup.vue?vue&type=template&id=e64c0428&scoped=true&"
import script from "./AdminResetSharedAccountPasswordPopup.vue?vue&type=script&lang=js&"
export * from "./AdminResetSharedAccountPasswordPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminResetSharedAccountPasswordPopup.vue?vue&type=style&index=0&id=e64c0428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64c0428",
  null
  
)

export default component.exports